// PLEASE THINK TWICE BEFORE CHANGING THIS FILE
// let webpack know how to resolve dependencies for static assets
// and dynamic imports
// @ts-ignore
/* eslint-disable import/no-commonjs */
__webpack_public_path__ = window.webpackPublicPath // wait for the dom to be loaded before attempting to start up the app

// Initialize ModXO integration IMMEDIATELY - ALWAYS, not just on specific routes
// This must happen synchronously during script load, before any React rendering
const { isInIframe } = require('./shared/utils/utils')
require('./initializeApp')

// wait for the dom to be loaded before attempting to start up the app
document.addEventListener('DOMContentLoaded', () => {
  // this is the only `require` that should be in our app. Using `require` here
  // allows us to defer import resolution until after the DOMContentLoaded
  // event is fired.
  if (!isInIframe()) {
    require('./render')
  }
})
